import React, { useContext } from 'react';
import context from '../context';
import styled from 'styled-components';
import { Container } from 'react-bootstrap';
import Link from "../components/link";

import Logo from './logo';
import { NavLink as BaseNavLink } from '../styled-components';

const Header = styled.header`
  background-color: #fff;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
`;

const Navigation = styled.nav`
  padding: .5rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const NavList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 auto;
  display: ${props => props.horizontal ? "flex" : "block"};
  text-align: center;
  position: relative;
  width: fit-content;

  &::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 52%;
    transform: translateX(-50%);
    width: 90%; /* Ajusta según lo largo que quieras el subrayado */
    height: 4px;
    background-color: #5A2CA0;
    border-radius: 2px;
  }
`;

const NavItem = styled.li`
  margin: 0 1rem;
`;

const NavLink = styled(BaseNavLink)`
  padding: 0.5rem 1.5rem;
  color: ${props => props.dark ? '#000' : '#fff'};
  text-decoration: none;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 0.85rem;
  white-space: nowrap;
  display: inline-block;
  text-align: center;
`;

export default ({ dark }) => {
  const state = useContext(context);

  return (
    <Header className="d-none d-lg-block">
      <Container>
        <Navigation>
          <Link to="/">
            <Logo dark={dark} light={!dark} />
          </Link>
          <NavList horizontal>
            <NavItem>
              <Link to="/about">
                <NavLink dark>
                  NOSOTROS
                </NavLink>
              </Link>            
            </NavItem>            
            <NavItem>
              <Link to="/gestion">
                <NavLink dark>
                  GESTIÓN INMOBILIARIA
                </NavLink>
              </Link>            
            </NavItem>
            <NavItem>
              <Link to="/temporalrent">
                <NavLink dark>
                  ARRIENDOS TEMPORALES
                </NavLink>
              </Link>            
            </NavItem>       
            <NavItem>
              <Link to="/contact">
                <NavLink dark>
                  INVERSIONISTAS
                </NavLink>
              </Link>                                    
            </NavItem>
            {/* 👇 Nuevo item Blog */}
            <NavItem>
              <Link to="/blog">
                <NavLink dark>
                  BLOG
                </NavLink>
              </Link>                                    
            </NavItem>
          </NavList>
        </Navigation>
      </Container>
    </Header>
  );
};